<div class="container-fluid">
    <!-- <div class="content-wrap4">
        <div class="width50">
            <ul class="nav nav-pills mb-1 mt-4" id="pills-tab" role="tablist">
                
                <li class="nav-item ">
                    <a class="nav-link active" id="pills-profile-tab" data-toggle="pill" href="#pills-profile"   role="tab"
                        aria-controls="pills-profile" aria-selected="true">Performance</a>
                </li>
            </ul>
        </div>

    
    </div> -->
    <div class="clear-both"></div>
    <div class="content-wrap2 min-ht500">
        <div class="tab-content" id="pills-tabContent"  >
          
            <div class="tab-pane fade  show active" id="pills-profile" role="tabpanel" aria-labelledby="pills-profile-tab">
                <div class="tab-pane fade show active" id="pills-profile" role="tabpanel"
                    aria-labelledby="pills-home-tab">

                    <div class="row mt-4">
                        <div class="col-xl-4 col-lg-12">
                            <div class="dashboard-card2">
                                <h3 class="stats-hd">Online Verifiers</h3>
                                <div class="line"></div>
                                <div class="row mt-3">
                                    <div class="col-md-6">
                                        <label class="date-label">From</label>
                                        <input type="date" class="stat-date" (change)="firstDateChange()" [max]="getToday()"  
                                            [(ngModel)]="firstDate">
                                    </div>
                                    <div class="col-md-6">
                                        <label class="date-label">Till</label>
                                        <input type="date" class="stat-date" (change)="lastDateChange()" [max]="getToday()"  
                                            [(ngModel)]="lastDate">
                                    </div>
                                </div>
                                <div class="row mt-3">
                                    <div class="col-md-12">
                                        <table class="table">
                                            <thead>
                                                <tr>
                                                    <th>Verified Id</th>
                                                    <th>Name</th>
                                                    <th>Record Processed</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr *ngFor="let data of getOnlineVerifiers">
                                                    <td>{{data.verId}}</td>
                                                    <td>{{data.fullNm}}</td>
                                                    <td>{{data.count}}</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-xl-8 col-lg-12">
                            <div class="row">
                                <div class="col-xl-6 col-lg-12">
                                    <div class="dashboard-card3">
                                        <h3 class="stats-hd">Verifier Performance- Monthly</h3>
                                        <div class="line"></div>
                                        <div class="row mt-3">
                                            <div class="col-md-6">
                                                <label class="date-label">Select Month</label>
                                                <input type="month" class="stat-date"  pattern="[0-9]{2}/[0-9]{4}" [(ngModel)]="monthyear"  
                                                (change)="changemonth()" name="start" value="05/2021" >
                                                <!-- <input type="date" class="stat-date" (change)="firstDateChange()"  [(ngModel)]="firstDate" > -->
                                            </div>

                                        </div>
                                        <app-bar-chart-monthly [countMonthly]="monthyearFormat"></app-bar-chart-monthly>
                                        <!-- <app-bar-chart-monthly [countMonthly]="monthyearFormat"></app-bar-chart-monthly> -->
                                    </div>

                                </div>
                                <div class="col-xl-6 col-lg-12">
                                    <div class="dashboard-card3">
                                        <h3 class="stats-hd">Verifier Performance- Daily</h3>
                                        <div class="line"></div>
                                        <div class="row mt-3">
                                            <div class="col-md-6">
                                                <label class="date-label">Select Date</label>
                                                <input type="date" class="stat-date" [(ngModel)]="datewise"  
                                                (change)="changedate()" name="start" [max]="getToday()"  >
                                                <!-- <input type="date" class="stat-date" (change)="firstDateChange()"  [(ngModel)]="firstDate" > -->
                                            </div>

                                        </div>
                                        <app-bar-chart-daily [countDaily]="datewise"></app-bar-chart-daily>
                                        <!-- <app-pie-chart-request-ratio [countRequests]="selectYear"></app-pie-chart-request-ratio> -->
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>


</div>